import { Injectable } from '@angular/core';

import { Site } from '../../models';
import { SitesComboboxModel } from './models';

@Injectable({
    providedIn: 'root'
})

export class SitesComboboxService {

    model: SitesComboboxModel = new SitesComboboxModel();
    constructor() { }

    setSelectedSite(site: Site | null | undefined): void {
        if (!site?.id) {
            this.model.selectedSite = null;
            return;
        }

        if (this.model.selectedSite?.id === site.id) {
            return;
        }

        this.model.selectedSite = site;
    }
}
